// src/api/permessi.ts
//
// Permessi dell'utente in sessione, come li ha calcolati il backend
// (UserResource.permissions, wildcard già espanse). Il frontend non ricalcola
// nulla: chiede solo se un'azione è nell'elenco.
//
// È ergonomia (nascondere ciò che non si può fare): l'autorizzazione vera la
// applica l'API. Il catalogo completo sta in api/config/permissions.php.

export type Ruolo = 'admin' | 'office' | 'agent'

export interface UtenteSessione {
  id?: number
  name?: string
  email?: string
  role?: Ruolo
  is_agent?: boolean
  avatar_url?: string | null
  permissions?: string[]
}

/** L'utente salvato in localStorage da login e checkToken. */
export function utenteCorrente(): UtenteSessione {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}') ?? {}
  } catch {
    return {}
  }
}

/** true se l'utente ha il permesso (es. `orders.delete`). */
export function can(permesso: string): boolean {
  return (utenteCorrente().permissions ?? []).includes(permesso)
}

/** true se l'utente ha almeno uno dei permessi indicati. */
export function canAny(permessi: string[]): boolean {
  const miei = utenteCorrente().permissions ?? []
  return permessi.some((p) => miei.includes(p))
}

export const ETICHETTE_RUOLO: Record<Ruolo, string> = {
  admin: 'Amministratore',
  office: 'Ufficio',
  agent: 'Agente',
}
